<template>
  <div class="page-container">
    <AppHeader title="Settings" />
    
    <div class="content-wrapper">
      <div class="settings-card">
        <!-- Checkboxes Section -->
        <div class="section-title">General Options</div>
        <div class="checkbox-grid">
          <div 
            class="permission-card" 
            :class="{ active: appData.pesapal_on }" 
            @click="appData.pesapal_on = !appData.pesapal_on"
          >
            <div class="custom-checkbox">
              <i class="fa fa-check checkmark"></i>
            </div>
            <span>Pesapal On</span>
          </div>

          <div 
            class="permission-card" 
            :class="{ active: appData.qty_check }" 
            @click="appData.qty_check = !appData.qty_check"
          >
            <div class="custom-checkbox">
              <i class="fa fa-check checkmark"></i>
            </div>
            <span>Quantity Check</span>
          </div>

          <div 
            class="permission-card" 
            :class="{ active: appData.efris_on }" 
            @click="appData.efris_on = !appData.efris_on"
          >
            <div class="custom-checkbox">
              <i class="fa fa-check checkmark"></i>
            </div>
            <span>Efris On</span>
          </div>

          <div 
            class="permission-card" 
            :class="{ active: appData.isSuspend }" 
            @click="appData.isSuspend = !appData.isSuspend"
          >
            <div class="custom-checkbox">
              <i class="fa fa-check checkmark"></i>
            </div>
            <span>Is Suspended</span>
          </div>

          <div 
            class="permission-card" 
            :class="{ active: appData.allow_sync }" 
            @click="appData.allow_sync = !appData.allow_sync"
          >
            <div class="custom-checkbox">
              <i class="fa fa-check checkmark"></i>
            </div>
            <span>Allow Sync Products</span>
          </div>
        </div>

        <!-- Inputs Section -->
        <div class="section-title mt-4">Configuration</div>
        <div class="inputs-grid">
          <div class="form-group">
            <label>Efris Link</label>
            <input type="text" v-model="appData.efris_link" class="form-control">
          </div>

          <div class="form-group">
            <label>Cost Center</label>
            <input type="text" v-model="appData.cost_center" class="form-control">
          </div>

          <div class="form-group">
            <label>Mtn Url</label>
            <input type="text" v-model="appData.mtn_url" class="form-control">
          </div>

          <div class="form-group">
            <label>Sales Invoice Prefix</label>
            <input type="text" v-model="appData.sales_invoice_prefix" class="form-control">
          </div>

          <div class="form-group">
            <label>Points To Giftcard</label>
            <input type="text" v-model="appData.points_to_giftcard" class="form-control">
          </div>

          <div class="form-group">
            <label>Scale Barcode Length</label>
            <input type="text" v-model="appData.scale_barcode_length" class="form-control">
          </div>

          <div class="form-group">
            <label>Suffix Length</label>
            <input type="text" v-model="appData.suffix_length" class="form-control">
          </div>
        </div>

        <!-- Actions -->
        <div class="actions-row">
            <button class="btn btn-danger action-btn" @click="cancelsettings">Cancel</button>
            <button class="btn btn-success action-btn" v-if="userId !== -1" @click="updatesetting">Update</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonServices from "@/shared/commonServices";
import MainMenu from "@/components/MainMenu";
import AppHeader from "@/components/AppHeader";
import Void from "@/components/Void";
import axios from "axios";

export default {
    mixins: [commonServices],
    components: { MainMenu, Void, AppHeader }, 
    mounted() {
      if (localStorage.userId !== undefined && localStorage.appId !== undefined) {
        // Logged in
      } else {
        this.$router.push({ name: 'login' });
      }
      this.language = 'ar';
      this.getData();
    },   
    data: function(){
        return {
            jsonData: {},
            appData: {},
            settingJson: {},
            userId: Number(localStorage.userId ?? -1),
        }
    },
    methods: {
      cancelsettings() {
        this.$router.back();
      },
      toBoolean(value) {
        if (value === true || value === false) return value;
        if (value === 1 || value === "1") return true;
        if (value === 0 || value === "0") return false;
        if (value === "true") return true;
        if (value === "false") return false;
        return !!value;
      },
      normalizeAppData(row) {
        const normalized = { ...row };

        normalized.pesapal_on = this.toBoolean(row.pesapal_on);
        normalized.qty_check = this.toBoolean(row.qty_check);
        normalized.efris_on = this.toBoolean(row.efris_on);
        normalized.isSuspend = this.toBoolean(row.isSuspend);
        normalized.allow_sync = this.toBoolean(row.allow_sync);

        normalized.efris_link = row.efris_link ?? "";
        normalized.cost_center = row.cost_center ?? "";
        normalized.mtn_url = row.mtn_url ?? "";
        normalized.sales_invoice_prefix = row.sales_invoice_prefix ?? "";
        normalized.points_to_giftcard = row.points_to_giftcard ?? "";
        normalized.scale_barcode_length = row.scale_barcode_length ?? "";
        normalized.suffix_length = row.suffix_length ?? "";

        return normalized;
      },
      updatesetting: async function () {
            this.settingJson = {
              pesapal_on: this.appData.pesapal_on ? 1 : 0,
              id: this.userId,
              qty_check: this.appData.qty_check ? 1 : 0,
              efris_on: this.appData.efris_on ? 1 : 0,
              isSuspend: this.appData.isSuspend ? 1 : 0,
              allow_sync: this.appData.allow_sync ? 1 : 0,
              name: this.appData.name,
              customer_name: this.appData.customer_name,
              room_id: this.appData.room_id,
              efris_link: this.appData.efris_link,
              cost_center: this.appData.cost_center,
              sales_invoice_prefix: this.appData.sales_invoice_prefix,
              mtn_url: this.appData.mtn_url,
              points_to_giftcard: this.appData.points_to_giftcard,
              scale_barcode_length: this.appData.scale_barcode_length,
              suffix_length: this.appData.suffix_length,
            };

            try {
                let dataURL = this.apiURL + 'Shared/updateApp';
                let response = await axios.post(dataURL, this.settingJson);
                if (response.data.status === 'success') {
                    localStorage.setItem('allow_sync', this.appData.allow_sync ? 1 : 0);
                    this.showSuccess("Settings Updated Successfully!");
                    this.cancelsettings();
                } else {
                    this.showAlert("Error Happened Please Check Entered Data!");
                }
            }
            catch (error) {
                console.log(error);
            }
        },
        getData: async function () {
            try {
                let dataURL = this.apiURL + 'Shared/getSetting';
                let response = await axios.post(dataURL);
                if (response.data.status === 'success') {
                  this.appData = this.normalizeAppData(response.data.rows?.[0] || {});
                } else {
                    this.showAlert("Error Happened Please Check Entered Data!");
                }
            }
            catch (error) {
                console.log(error);
            }
        },
    }
  }
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  background-color: var(--theme-bg-end);
  color: var(--theme-text-main);
}

.content-wrapper {
  padding: 20px;
  display: flex;
  justify-content: center;
}

.settings-card {
  background: var(--form-color);
  border-radius: 12px;
  padding: 30px;
  width: 100%;
  max-width: 800px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}

.section-title {
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  padding-bottom: 10px;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.permission-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
}

.permission-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.permission-card.active {
  background: rgba(92, 107, 192, 0.2); 
  border-color: var(--theme-primary);
  box-shadow: 0 4px 12px rgba(92, 107, 192, 0.15);
}

.custom-checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(0,0,0,0.1);
  flex-shrink: 0;
}

.permission-card.active .custom-checkbox {
  background: var(--theme-primary);
  border-color: var(--theme-primary);
  transform: scale(1.05);
}

.checkmark {
  font-size: 14px;
  color: white;
  opacity: 0;
  transform: scale(0.5);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.permission-card.active .checkmark {
  opacity: 1;
  transform: scale(1);
}

.permission-card span {
  color: white;
  font-size: 1.2rem;
}

.inputs-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.form-group {
  margin-bottom: 10px;
}

.form-group label {
  display: block;
  color: #ccc;
  margin-bottom: 5px;
}

.form-control {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 6px;
  padding: 10px;
}

.form-control:focus {
  background: rgba(255, 255, 255, 0.15);
  border-color: var(--theme-primary);
  box-shadow: none;
}

.actions-row {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

.action-btn {
  padding: 10px 30px;
  font-size: 1.1em;
}

@media (max-width: 768px) {
  .checkbox-grid, .inputs-grid {
    grid-template-columns: 1fr;
  }
}
</style>
